<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Показать ' + this.topCount : 'Показать все'" :expandable="items.length > topCount">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        Компаний под управлением ({{items.length > 100 ? 'более 100' : items.length}})
        <template v-for="item in topItems">
          <div>
            <span v-html="renderReference(item.ref.value)"></span>
            <v-component :is="renderFlags(item.ref.value.flags, true)" />
            <v-flex pl-2>
              <div>ИНН <b><span v-html="renderInnHtml(item.ref.value.inn)"></span></b> - 
                <span v-html="renderStatus(item.ref.value.status)"></span>
              </div>
              <span v-html="renderFirstActivityHtml(item.ref.value.activities)"></span>
            </v-flex>
            <span v-html="renderUnreliableHtml(item)"></span>
          </div>
        </template>      
      </div>  
    </v-panel-title>
    <v-card-text v-show="isLoaded && items.length > 0" class="pt-0">
      <v-flex v-if="items.length===0">
      Данные не найдены.
      </v-flex>
      <div v-show = "items.length > 0 && items.length > 100">
        <b>ВАЖНО!</b> Показываются только 100 компаний под управлением. Для показа всех компаний под управлением направьте нам письмо на электронную почту {{getOpenSettings.supportMail}}<br/><br/>
      </div>                
      <template v-for="item in lastItems">
        <div>
          <span v-html="renderReference(item.ref.value)"></span>
          <v-component :is="renderFlags(item.ref.value.flags, true)" />
          <v-flex pl-2>
            <div>ИНН <b><span v-html="renderInnHtml(item.ref.value.inn)"></span></b> - 
              <span v-html="renderStatus(item.ref.value.status)"></span>
            </div>
            <span v-html="renderFirstActivityHtml(item.ref.value.activities)"></span>
          </v-flex>
          <span v-html="renderUnreliableHtml(item)"></span>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import vPanelTitle from './PanelTitle'

  export default {
    name: 'v-manageds-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      items: [],
      isLoaded: false,
      isLoading: false
    }),
    props: {
      ogrn: {
        type: Number,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      },
      topCount: {
        type: Number,
        default: 2
      }
    },
    watch: {
      ogrn: function (newVal, oldVal) { // watch it
        this.id = newVal
        if (this.id) {
          this.fetchItems()
        }
      }
    },
    computed: {
      ...mapGetters({
        renderReference: 'renderReference',
        renderInnHtml: 'renderInnHtml',
        renderDateSince: 'renderDateSince',
        renderStatus: 'renderStatus',
        renderFlags: 'renderFlags',
        renderFirstActivityHtml: 'renderFirstActivityHtml',
        renderShare: 'renderShare',
        renderUnreliableHtml: 'renderUnreliableHtml',
        getOpenSettings: 'getOpenSettings'
      }),
      topItems () {
        return this.items.slice(0, this.topCount)
      },
      lastItems () {
        return this.items.slice(this.topCount)
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
          this.fetchItems()
        }
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о компаниях под управлением из ЕГРЮЛ '})
        }
        server.openApiGet(
          '/openapi/companies/' + id + '/manageds',
          cb,
          cbError)
      },
      fetchItems () {
        if (this.id && !this.isLoading) {
          this.items = []
          this.isLoading = true
          this.getItems(this.id, (data) => {
            this.items = data
            this.isLoading = false
          })
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// ManagedsPanel.vue?50584856